































































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";

import CapabilitiesCard from "../components/vehicle-detail/CapabilitiesCard.vue";
import { capitalCase } from "change-case";
const { DateTime, Interval } = require("luxon");
import MileageCard from "../components/vehicle-detail/MileageCard.vue";
import ResidualValueCard from "../components/vehicle-detail/ResidualValueCard.vue";
import StatCard from "../components/vehicle-detail/StatCard.vue";
import VehicleDetailHeader from "../components/vehicle-detail/VehicleDetailHeader.vue";
import VehicleHistoryCard from "../components/vehicle-detail/VehicleHistoryCard.vue";
import VehicleInformationCard from "../components/vehicle-detail/VehicleInformationCard.vue";
import VehiclesTable from "../components/vehicles/VehiclesTable.vue";
import Vehicle from "../models/vehicle";

const vehicle = namespace("vehicle");

@Component({
  components: {
    CapabilitiesCard,
    MileageCard,
    ResidualValueCard,
    StatCard,
    VehicleDetailHeader,
    VehicleHistoryCard,
    VehicleInformationCard,
    VehiclesTable,
  },
})
export default class VehicleDetail extends Vue {
  get breadcrumbs(): any[] {
    return [
      { text: "Vehicles", to: "/vehicles", exact: true },
      { text: this.vin, to: `/vehicles/${this.vin}`, exact: true },
    ];
  }

  @vehicle.Getter("isLoading")
  isLoading!: boolean;

  get lifecycleStage(): string {
    if (!this.vehicle || !this.vehicle.saleClass) {
      return "No Data";
    }
    return capitalCase(this.vehicle.saleClass);
  }

  @vehicle.Getter("getDetailedVehicle")
  vehicle!: Vehicle | null;

  get vin(): string {
    return this.$route.params.vin;
  }

  get priceDetails(): any {
    if (!this.vehicle) {
      return { title: "No Data", subtitle: "MSRP" };
    }

    if (this.vehicle.lastSalePrice != null) {
      return {
        title: this.formatCurrency(this.vehicle.lastSalePrice, {}),
        subtitle: "Current Residual Value",
      };
    }

    if (this.vehicle.msrp != null) {
      return {
        title: this.formatCurrency(this.vehicle.msrp, {}),
        subtitle: "MSRP",
      };
    }

    return { title: "No Data", subtitle: "MSRP" };
  }

  get title(): string {
    if (!this.vehicle) {
      return "";
    }
    return this.vehicle.displayName();
  }

  @vehicle.Action("fetchByVin")
  fetchByVin!: (vin: string) => Promise<any>;

  get daysInInventory(): any {
    if (!this.vehicle || !this.vehicle.purchasedAt) {
      return { title: "No Data", subtitle: "Days in Inventory" };
    }

    const dt = DateTime.fromISO(this.vehicle.purchasedAt);
    const days = Interval.fromDateTimes(dt, DateTime.local()).toDuration(
      "days"
    ).days;

    if (days < 1) {
      return { title: "< 1 Day", subtitle: "In Inventory" };
    } else if (days >= 1 && days < 2) {
      return { title: "1 Day", subtitle: "In Inventory" };
    } else {
      return { title: `${Math.round(days)} Days`, subtitle: "In Inventory" };
    }
  }

  formatCurrency(val: number | null, _opts: any): string {
    if (!val) {
      return "$--";
    }

    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: 0,
    }).format(val);
  }

  mounted(): void {
    if (this.isLoading) {
      return;
    }
    this.fetchByVin(this.vin);
  }
}
